import { ServerActionRequest } from "../../../api/dtos/server/ServerActionRequest";
import { ServerCardData } from "../../../api/dtos/server/ServerCardResponse";
import { ServerData } from "../../../api/dtos/server/ServerResponse";
import { GlobalApiActionTypes } from "../types";

export interface ServerState {
    server: ServerData | null;
    servers: ServerData[];
    serversCards: ServerCardData[];
    isLoaded: boolean;
}

export const API_SERVERS_LOADED = 'API_SERVERS_LOADED';
export const API_SERVER_LOADED = 'API_SERVER_LOADED';
export const API_SERVER_ADDED = 'API_SERVER_ADDED';
export const API_SERVER_REMOVED = 'API_SERVER_REMOVED';
export const API_SERVER_DEPLOYED = 'API_SERVER_DEPLOYED';
export const API_SERVER_ACTION_UPDATED = 'API_SERVER_ACTION_UPDATED';
export const API_SERVERS_ACTION_UPDATED = 'API_SERVERS_ACTION_UPDATED';

interface ServersLoadedAction {
    type: typeof API_SERVERS_LOADED;
    servers: ServerData[];
}

interface ServerLoadedAction {
    type: typeof API_SERVER_LOADED;
    server: ServerData;
}

interface ServerAddedAction {
    type: typeof API_SERVER_ADDED;
    server: ServerData;
}

interface ServerRemovedAction {
    type: typeof API_SERVER_REMOVED;
    serverId: number;
}

interface ServerDeployedAction {
    type: typeof API_SERVER_DEPLOYED;
}

interface ServerActionUpdatedAction {
    type: typeof API_SERVER_ACTION_UPDATED;
    serverId: number;
    isStarted: ServerActionRequest;
}

interface ServersActionUpdatedAction {
    type: typeof API_SERVERS_ACTION_UPDATED;
    isStarted: ServerActionRequest;
}

//public
export const API_SERVERS_CARD_LOADED = 'API_SERVERS_CARD_LOADED';

interface ServersCardLoadedAction {
    type: typeof API_SERVERS_CARD_LOADED;
    serversCards: ServerCardData[];
}
export type ServerActionTypes =
    GlobalApiActionTypes
    | ServersLoadedAction
    | ServerLoadedAction
    | ServerAddedAction
    | ServerRemovedAction
    | ServerDeployedAction
    | ServerActionUpdatedAction
    | ServersActionUpdatedAction
    | ServersCardLoadedAction;